import axios from "axios";

const AssignJobsService = axios.create({
  //baseURL: "http://172.30.30.96:9000/api/attendance/",//baseURL: "https://esystems.cdl.lk/QRApp_BackEnd/api/attendance/",
  //baseURL: "http://172.30.30.96:2500/attme/",
  baseURL: "https://esystems.cdl.lk/backend/AttendMe2/attme/",
  // baseURL: "http://localhost:51976/attme/",
  //  baseURL: "http://localhost:51976/attme/",
  
  headers: {
    UserId: "DTSUSER",
    Password: "Dts@10099",
  },
});



export default AssignJobsService;

// import axios from "axios";

// const AssignJobsService = {
//   getJobs: (date, serviceNumber) =>
//     axios.get(
//       `attme/GetJobs?date=${date}&serviceNo=${serviceNumber}`,
//       {
//         headers: {
//           UserId: "DTSUSER",
//           Password: "Dts@10099",
//         },
//       }
//     ),
//     getLocationby: (company) =>
//     axios.get(
//       `attme/GetLocationsByCompany?company=${company}`,
//       {
//         headers: {
//           UserId: "DTSUSER",
//           Password: "Dts@10099",
//         },
//       }
//     ),
//     assignJob: (assignmentData) =>
//     axios.post(
//       `attme/AssignJob`,
//       assignmentData,
//       {
//         headers: {
//           UserId: "DTSUSER",
//           Password: "Dts@10099",
//         },
//       }
//     ),
// };

// export default AssignJobsService;



